import { Box, Text } from "@modernatx/ui-kit-react";
import React, { FC } from "react";

export const DisplayPaymentInfo: FC<{
  fieldName: string;
  fieldValue: string | string[] | undefined;
}> = ({ fieldName, fieldValue }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      mt: "spacing-3"
    }}
  >
    <Text variant="body-1-regular">{fieldName}</Text>
    {Array.isArray(fieldValue) ? (
      <Box sx={{ display: "flex", flexDirection: "column", textAlign: "end" }}>
        {fieldValue.map((item, index) => (
          <Text key={`${index}-payment-info`} variant="body-1-medium">
            {item}
          </Text>
        ))}
      </Box>
    ) : (
      <Text variant="body-1-medium">{fieldValue}</Text>
    )}
  </Box>
);

export default DisplayPaymentInfo;
